import Barba from 'barba.js';
import AbstractModule from './AbstractModule';
import { $body, $window, $document } from '../utils/environment';

export default class extends AbstractModule {
    constructor(options) {
        super(options);

        this.init();
    }

    /**
     * Initialisation.
     *
     * @return {void}
     */
    init() {
        this.$el.on('change', (e) => {
            var $this = $(e.currentTarget);
            if ($this.find(':selected').val()) {
                $window.scrollTop(0);
                Barba.Pjax.goTo($this.find(':selected').val());
            }
        });
    }

    /**
     * Déstructeur.
     *
     * @return {void}
     */
    destroy() {
        this.$el.off('.HeaderTabs');
    }
}
